<mat-icon *ngIf="working" class="working-on-printing-cd-icon worklist-success-failure-icon-font">build_circle</mat-icon>

<mat-icon *ngIf="failure" class="failure-on-printing-cd-icon worklist-success-failure-icon-font">error</mat-icon>

<mat-icon *ngIf="success" class="success-on-printing-cd-icon worklist-success-failure-icon-font">check_circle</mat-icon>

<mat-icon *ngIf="warning" class="warning-on-printing-cd-icon worklist-success-failure-icon-font">error</mat-icon>

